import React from 'react';

/**
 * Tableau des lignes de cotisations
 */
export function PayrollTable({ employeeLines = [], employerLines = [] }) {
  const formatAmount = (amount) => {
    if (amount === null || amount === undefined || isNaN(amount)) return '-';
    return amount.toFixed(2);
  };

  const formatRate = (rate) => {
    if (rate === null || rate === undefined) return '-';
    return `${parseFloat(rate).toFixed(2)}%`;
  };

  return (
    <div className="payroll-table-container">
      <table className="payroll-table">
        <thead>
          <tr>
            <th>Libellé</th>
            <th>Base</th>
            <th>Taux</th>
            <th>Part salarié</th>
            <th>Part employeur</th>
          </tr>
        </thead>
        <tbody>
          {/* Lignes combinées : on affiche chaque code unique avec parts salarié ET employeur */}
          {(() => {
            // Créer un map de toutes les lignes par code
            const linesByCode = new Map();

            // Ajouter les cotisations salariales
            employeeLines.forEach(line => {
              if (!linesByCode.has(line.code)) {
                linesByCode.set(line.code, {
                  code: line.code,
                  label: line.label,
                  base: line.base,
                  rate: line.rate,
                  employee_amount: line.amount,
                  employer_amount: 0
                });
              } else {
                const existing = linesByCode.get(line.code);
                existing.employee_amount += line.amount;
              }
            });

            // Ajouter les cotisations employeur
            employerLines.forEach(line => {
              if (!linesByCode.has(line.code)) {
                linesByCode.set(line.code, {
                  code: line.code,
                  label: line.label,
                  base: line.base,
                  rate: line.rate,
                  employee_amount: 0,
                  employer_amount: line.amount
                });
              } else {
                const existing = linesByCode.get(line.code);
                existing.employer_amount += line.amount;
                // Prendre la base/rate de l'employeur si plus élevé
                if (line.base > existing.base) {
                  existing.base = line.base;
                  existing.rate = line.rate;
                }
              }
            });

            // Convertir en array et trier par code
            return Array.from(linesByCode.values()).map(line => (
              <tr key={line.code}>
                <td className="payroll-table-label">{line.label}</td>
                <td className="payroll-table-base">{formatAmount(line.base)}</td>
                <td className="payroll-table-rate">{formatRate(line.rate)}</td>
                <td className="payroll-table-employee">{formatAmount(line.employee_amount)}</td>
                <td className="payroll-table-employer">{formatAmount(line.employer_amount)}</td>
              </tr>
            ));
          })()}
        </tbody>
      </table>
    </div>
  );
}
